import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { supportUrl } from 'Config/lang';
import ConfirmAccount from 'Components/Account/ConfirmAccount';
import SupportFAQ from 'Components/Account/Support/SupportFAQ';
import SupportQuestions from 'Components/Account/Support/SupportQuestions';

function Support({ intl }) {
  const { formatMessage } = intl;

  return (
    <section className="account-content account-support">
      <ConfirmAccount />
      <div className="title-button-container">
        <div className="title-container">
          <h1>
            <FormattedMessage id="account.support.header" defaultMessage="Support" />
          </h1>
        </div>

        <div className="button-container">
          <a
            href={`${supportUrl()}`}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-line-account"
          >
            <FormattedMessage id="account.support.button" defaultMessage="Go to the Support Centre" />
          </a>
        </div>
      </div>
      <p>
        <FormattedMessage id="account.support.introduction" defaultMessage="We're here to help! Check out our FAQs or click the button to go through to our full support centre." />
      </p>

      <div className="account-table support-faqs">
        <div className="account-table-heading">
          <FormattedMessage id="account.support.subheader" defaultMessage="Frequently Asked Questions" />
        </div>

        <SupportFAQ
          question={formatMessage(SupportQuestions.how_to_use_steam_key)}
          supportArticle="201101161-How-do-I-use-my-new-Steam-Keys-"
        />

        <SupportFAQ
          question={formatMessage(SupportQuestions.how_to_use_ubisoft_key)}
          supportArticle="115005328429-How-do-I-use-my-new-Uplay-Keys-"
        />

        <SupportFAQ
          question={formatMessage(SupportQuestions.how_to_use_all_other_key)}
          supportArticle="115005516509-How-do-I-use-my-new-keys-"
        />

        <SupportFAQ
          question={formatMessage(SupportQuestions.key_time_limit)}
          supportArticle="207289349-Do-I-have-a-time-limit-for-redeeming-a-key-"
        />

        <SupportFAQ
          question={formatMessage(SupportQuestions.why_manual_auth)}
          supportArticle="201027912-Order-Status-Manual-Authorisation-Why-do-I-have-them-"
        />

        <SupportFAQ
          question={formatMessage(SupportQuestions.activate_gift_card)}
          supportArticle="10821046183057-How-do-I-activate-my-gift-card-"
        />
      </div>
    </section>
  );
}

export default injectIntl(Support);
